import o from "./AppTag.vue2.js";
import './AppTag.css';/* empty css            */
import p from "../_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ p(o, [["__scopeId", "data-v-b40056ac"]]);
export {
  m as default
};
//# sourceMappingURL=AppTag.vue.js.map
